import { render, staticRenderFns } from "./users.vue?vue&type=template&id=4e778408&"
import script from "./users.vue?vue&type=script&lang=js&"
export * from "./users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e778408')) {
      api.createRecord('4e778408', component.options)
    } else {
      api.reload('4e778408', component.options)
    }
    module.hot.accept("./users.vue?vue&type=template&id=4e778408&", function () {
      api.rerender('4e778408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/users.vue"
export default component.exports